export default "__VITE_ASSET__DG4ZW$Ra__"